/* GENERATED by scripts/gen-data.mjs — the spacing rule the Review chip implements (from s4.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

export const SRS = {
  "HALF": [
    1,
    3,
    7,
    21
  ],
  "TARGET": 0.7,
  "DAY": 86400000
} as const;

export const STORAGE_KEY = "od-ai-formation-v2";

export const LANG_KEY = 'formation-ia-produit.lang';
